import { PropsWithChildren, ReactNode } from 'react'

interface ShowProps extends PropsWithChildren {
  when: boolean
  fallback?: ReactNode
}

export const Show = ({ children = null, when, fallback = null }: ShowProps) => {
  return when ? <>{children}</> : <>{fallback}</>
}
